export const messages = {
  en: {
    returnPayFeeManage: {
      search: {
        title: 'Search Conditions',
        detailId: 'Payment Order Number',
        feeType: 'Select Fee Type',
        state: 'Select Audit Status',
        applyPersonName: 'Applicant Name',
        auditPersonName: 'Auditor Name',
        payerObjName: 'House Number/Car Number etc.',
        startTime: 'Start Time',
        endTime: 'End Time'
      },
      list: {
        title: 'Refund Application List'
      },
      table: {
        returnFeeId: 'Refund Order Number',
        detailId: 'Payment Order Number',
        feeType: 'Fee Type',
        payerObjName: 'Payment Object',
        cycles: 'Payment Cycle (Month)',
        amount: 'Payable Amount/Paid Amount',
        createTime: 'Application Time',
        reason: 'Refund Reason',
        applyPersonName: 'Applicant',
        state: 'Audit Status',
        auditPersonName: 'Auditor',
        retundRemark: 'Refund Status'
      },
      button: {
        retryRefund: 'Retry Refund'
      },
      message: {
        refundSubmitSuccess: 'Refund submitted successfully',
        refundSubmitFailed: 'Refund submission failed'
      },
      page: {
        subtitle: 'Review refund applications, then trigger the refund to the payer',
        empty: 'No refund applications found',
        loadFailed: 'Refund applications failed to load, please retry'
      }
    },
    audit: {
      title: 'Audit Information',
      state: 'Audit Status',
      selectState: 'Please Audit',
      approve: 'Approve',
      reject: 'Reject',
      remark: 'Reason',
      remarkPlaceholder: 'Required, please fill in the reason'
    }
  },
  zh: {
    returnPayFeeManage: {
      search: {
        title: '查询条件',
        detailId: '缴费单号',
        feeType: '选择费用类型',
        state: '选择审核状态',
        applyPersonName: '申请人姓名',
        auditPersonName: '审核人姓名',
        payerObjName: '房屋编号/车辆编号等',
        startTime: '开始时间',
        endTime: '结束时间'
      },
      list: {
        title: '退费申请单'
      },
      table: {
        returnFeeId: '退款单号',
        detailId: '缴费单号',
        feeType: '费用类型',
        payerObjName: '付费对象',
        cycles: '付费周期(月)',
        amount: '应付金额/实付金额',
        createTime: '申请时间',
        reason: '退费原因',
        applyPersonName: '申请人',
        state: '审核状态',
        auditPersonName: '审核人',
        retundRemark: '退款情况'
      },
      button: {
        retryRefund: '重试退款'
      },
      message: {
        refundSubmitSuccess: '提交退款成功',
        refundSubmitFailed: '提交退款失败'
      },
      page: {
        subtitle: '审核退费申请单，审核通过后向缴费人发起退款',
        empty: '暂无退费申请单',
        loadFailed: '退费申请单加载失败，请重试'
      }
    },
    audit: {
      title: '审核信息',
      state: '审核状态',
      selectState: '请审核',
      approve: '同意',
      reject: '拒绝',
      remark: '原因',
      remarkPlaceholder: '必填，请填写原因'
    }
  }
}